import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import ReactPhoneInput from "react-phone-input-2";

import { PCOperations } from "../../../../../redux/pageConfiguration/pcOperators";

export const PCBarber = ({
  PCInformation,
  setPhone_barber,
  setDisabledButton,
}) => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();

  const checkAvailabilityBarber = async () => {
    if (PCInformation.PCInformation.check_barber === 0) {
      dispatch(
        PCOperations.changeCheckBarber(1, PCInformation.PCInformation.id_user)
      );
    }
    if (PCInformation.PCInformation.check_barber === 1) {
      dispatch(
        PCOperations.changeCheckBarber(0, PCInformation.PCInformation.id_user)
      );
    }
  };

  const handleChange = (e) => {
    setDisabledButton(false);
    setPhone_barber(e, "phone_barber");
  };

  return (
    <>
      <div className="color-border border-div-availabilityCheck availabilityCheck mt-3">
        <div className="div-options-form">
          <Form.Check
            onClick={() => checkAvailabilityBarber()}
            type="switch"
            id="custom-switch"
            style={{ height: "2em !important" }}
            className="switch-schedule"
            text="Selecciona si tu negocio dispone de turno intensivo o partido"
            defaultChecked={PCInformation.PCInformation.check_barber}
          />
          <span className="text-color">
            {t("pageConfiguration.customerBarberAvailability")}
          </span>
        </div>
        {PCInformation?.PCInformation?.check_barber === 1 && (
          <Form.Group className="mb-2" id="phone">
            <Form.Label className="size-text-label color-text-secondary">
              {t("profile.textPhoneOtherServices")}
            </Form.Label>
            <div className="divMyAccount">
              <ReactPhoneInput
                id="idInputPhoneNumberForm"
                className="greyTextFormPhone color-text-secondary bg-input"
                inputExtraProps={{
                  name: "phone_barber",
                  required: true,
                  autoFocus: true,
                }}
                placeholder={t("pageConfiguration.textNewPhone")}
                value={
                  PCInformation.PCInformation?.phone_barber === null
                    ? PCInformation.PCInformation.phone_corporation
                    : PCInformation.PCInformation?.phone_barber
                }
                country="es"
                required
                onChange={(e) => handleChange(e)}
              />
            </div>
          </Form.Group>
        )}
      </div>
    </>
  );
};
